import dotProp from 'dot-prop-immutable'
import {
  LOAD_INFO_SETTING_PAGES_SUCCESS,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILURE,
  UPLOAD_USER_IMG_SUCCESS,
  UPLOAD_USER_IMG_FAILURE,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  LOAD_ALL_INTERESTS_SUCCESS,
  UPDATE_INTERESTS_SUCCESS,
  CANCLE_ERROR,
  ADD_WISHLIST_SUCCESS,
  UPDATE_FOLLOW_SUCCESS,
  CHECK_ACTIVE_SUCCESS,
  GET_COIN_SUCCESS,
  LOAD_EXAMHISTORY_SUCCESS,
  LOAD_EXAMPRODUCTHISTORY_SUCCESS,
} from '../actions/types'

const combinedInterest = (state, action) => {
  const { interests } = state
  const { payload: { categories } } = action
  const combined = categories.map((categorie) => {
    if (interests.findIndex(interest => interest._id === categorie._id) !== -1) {
      return dotProp.set(categorie, 'interested', true)
    }
    return dotProp.set(categorie, 'interested', false)
  })
  let newState = dotProp.set(state, 'categories', combined)
  return newState
}

const updateInterest = (state, action) => {
  const { categories } = state
  const { payload: { interest, interestsStatus } } = action
  const findCategorieById = categories.findIndex(categorie => categorie._id === interest._id)
  let newState = dotProp.set(state, `categories.${findCategorieById}.interested`, interestsStatus)
  return {
    ...newState,
  }
}

const updateIsWishList = (state, action) => {
  const { wishListCourse: currentWishListCourse, wishListExam: currentWishListExam } = state
  const indexWishlist = currentWishListCourse.findIndex(course => course._id === action.payload._id)
  if (indexWishlist > -1) {
    let newState = dotProp.delete(state, `wishListCourse.${indexWishlist}`)
    return {
      ...newState,
    }
  }
  const indexWishlistExam = currentWishListExam.findIndex(course => course._id === action.payload._id)
  if (indexWishlistExam > -1) {
    let newState = dotProp.delete(state, `wishListExam.${indexWishlistExam}`)
    return {
      ...newState,
    }
  }
  return {
    ...state,
  }
}

const updateFollowed = (state, action) => {
  const { followings: currentFollowings } = state
  const indexFollowings = currentFollowings.findIndex(creator => creator._id === action.payload._id)
  if (indexFollowings > -1) {
    let newState = dotProp.delete(state, `followings.${indexFollowings}`)
    return {
      ...newState,
    }
  }
  return {
    ...state,
  }
}

const initialPagesState = {
  updatePasswordError: null,
  updateInfoError: null,
  uploadImageError: null,
  categories: [],
  followings: [],
  interests: [],
  myLibCourse: [],
  myLibExam: [],
  myLibPackage: [],
  wishListCourse: [],
  wishListExam: [],
  myLibLivestream: [],
  shortDesc: '',
  _id: '',
  active: null,
  getcoin: [],
  usedTimer: [],
  nonUsedTimer: [],
  arrayAllTimer: [],
  doExamHistory: [],
}

const info = (state = initialPagesState, action) => {
  switch (action.type) {
    case LOAD_INFO_SETTING_PAGES_SUCCESS:{
      return {
        ...state,
        ...action.payload,
      }
    }
    case UPDATE_INFO_SUCCESS:
      return {
        ...state,
        updateInfoError: false,
      }
    case UPDATE_INFO_FAILURE:
      return {
        ...state,
        updateInfoError: true,
      }
    case UPLOAD_USER_IMG_SUCCESS:
      return {
        ...state,
        uploadImageError: false,
      }
    case UPLOAD_USER_IMG_FAILURE:
      return {
        ...state,
        uploadImageError: true,
      }
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordError: false,
      }
    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        updatePasswordError: true,
      }
    case CANCLE_ERROR:
      return {
        ...state,
        updatePasswordError: null,
        updateInfoError: null,
        uploadImageError: null,
      }
    case LOAD_ALL_INTERESTS_SUCCESS:
      return combinedInterest(state, action)
    case UPDATE_INTERESTS_SUCCESS:
      return updateInterest(state, action)
    case ADD_WISHLIST_SUCCESS:
      return updateIsWishList(state, action)
    case UPDATE_FOLLOW_SUCCESS:
      return updateFollowed(state, action)
    case CHECK_ACTIVE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case GET_COIN_SUCCESS:
      return {
        ...state,
        getcoin: action.payload,
      }
    case LOAD_EXAMHISTORY_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        arrayAllTimer: [
          ...action.payload.usedTimer,
          ...action.payload.nonUsedTimer,
        ],
      }
    }
    case LOAD_EXAMPRODUCTHISTORY_SUCCESS: {
      return {
        ...state,
        doExamHistory: action.payload,
      }
    }
    default:
      return state
  }
}
export default info



// WEBPACK FOOTER //
// ./src/reducers/info.js